module.exports = __webpack_public_path__ + "img/组 187.ec115085.png";